import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { StateManagementService } from 'src/services/statemanagement/statemanagement.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private userService: UserService,
                private oauthService: OAuthService,
                private stateManagementService:StateManagementService) { }


    redirectToLogin() {
        this.oauthService.initCodeFlow();
    }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        const hasValidIdToken = this.oauthService.hasValidIdToken();
        const hasValidAccessToken = this.oauthService.hasValidAccessToken();

        if (hasValidIdToken && hasValidAccessToken) {
            // verify client access and wait for result before activating the route
            return this.userService.verifyClientAccess();
        }
        else {
            this.stateManagementService.storeRouteBeforeLogin(state.url);
            this.redirectToLogin();
            return false;
        }
    }
}
